<template>
  <div>
    <Alert v-if="userMessage" :info="userMessage" />
    <router-view />
  </div>
</template>

<script>
import Alert from '@/components/DesignSystem/Alert';
import { mapGetters } from 'vuex';

export default {
  components: {
    Alert,
  },
  computed: {
    ...mapGetters(['userMessage']),
  },
};
</script>
